module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_yq_zhtx@2x.c661d1cf.png";